// src/pages/SharedAccessPage.jsx

import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const API_BASE = "http://localhost:4000";

export default function SharedAccessPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [status, setStatus] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("");

    const res = await fetch(`${API_BASE}/api/shared/${token}/request-access`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ code })
    });

    const data = await res.json();

    if (!res.ok) {
      setStatus(data.error || "Invalid access code");
      return;
    }

    navigate(`/shared/${token}`);
  }

  return (
    <div className="page-wrap">
      <h1>Enter Access Code</h1>

      <form className="form" onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="Access Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />

        {status && <div className="status">{status}</div>}

        <button type="submit">Enter</button>
      </form>
    </div>
  );
}
